<template>
	<div class="dropdown-list-item" v-on:click="click" v-on:mouseleave="unhover()" v-on:mouseenter="hover()" v-bind:class="{
		'disabled': disabled,
		'has-dropdown': hasDropdown,
		'on-right': isOnRight
	}">
		<SvgIcon :name="icon" />
		<slot />
		<div class="arrow" v-if="hasDropdown">
			<SvgIcon name="submenu" />
		</div>
	</div>
</template>

<script>
export default {
  props: [
    'icon',
    'disabled',
    'navigate',
    'open'
  ],
  data: () => ({
    hovered: false
  }),
  computed: {
    isOnRight() {
      return this.$parent.onRight
    },
    hasDropdown () {
      return this.withDropdown(() => {})
    }
  },
  methods: {
    withDropdown (fnc) {
      for (var slot of this.$slots.default) {
        if (slot.componentOptions ? (slot.componentOptions.tag == 'Dropdown') : false) {
          fnc(slot.componentInstance)

          return true
        }
      }

      return false
    },
    hover () {
      this.withDropdown(dropdown => dropdown.open())
    },
    unhover () {
      this.withDropdown(dropdown => dropdown.close())
    },
    click () {
      if (!this.disabled) {
        if (this.navigate) {
          this.$router.push(this.navigate)
        } else if (this.open) {
          window.open(this.open)
        } else {
          this.$emit('click')
        }
      }
    }
  }
}
</script>
